import { render, staticRenderFns } from "./passwordStrengthIndicator.vue?vue&type=template&id=4c52a952&scoped=true&"
import script from "./passwordStrengthIndicator.vue?vue&type=script&lang=js&"
export * from "./passwordStrengthIndicator.vue?vue&type=script&lang=js&"
import style0 from "./passwordStrengthIndicator.vue?vue&type=style&index=0&id=4c52a952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c52a952",
  null
  
)

export default component.exports